import dayjs from "dayjs";
import { FC } from "react";
import { useIntl } from "react-intl";

import { UserAvatar } from "~/components/ui/user-avatar";
import { formatDateOnly } from "~/utils/date";

import { User } from "~/api/model/user";
import { useParentCase } from "../hooks/useParentCase";
import { CasePropertyItem } from "./CasePropertyItem";

type CaseHeaderPropertiesProps = {
  totalPages: number;
  createdAt: string;
  author?: User;
};

export const CaseHeaderProperties: FC<CaseHeaderPropertiesProps> = ({
  totalPages,
  createdAt,
  author,
}) => {
  const { formatMessage } = useIntl();
  const { project: data } = useParentCase();

  if (!data) return null;

  const properties = [
    {
      label: formatMessage({ id: "caseHeader.dateOfBirth" }),
      value: data.dateOfBirth ? formatDateOnly(data.dateOfBirth) : undefined,
      className: "w-22",
      copyable: true,
    },
    {
      label: formatMessage({ id: "caseHeader.dateOfLoss" }),
      value: data.dateOfLoss ? formatDateOnly(data.dateOfLoss) : undefined,
      className: "w-22",
      copyable: true,
    },
    {
      label: formatMessage({ id: "caseHeader.claimNumber" }),
      value: data.claimNumber,
      className: "max-w-[210px]",
      copyable: true,
      truncate: true,
    },
    {
      label: formatMessage({ id: "caseHeader.created" }),
      value: dayjs(createdAt).format("MM/DD/YYYY, HH:mm"),
      className: "w-34",
      copyable: true,
    },
    {
      label: formatMessage({ id: "caseHeader.totalPages" }),
      value: totalPages.toString(),
      className: "w-22",
      copyable: true,
    },
    {
      label: formatMessage({ id: "caseHeader.createdBy" }),
      value: author ? (
        <div className="flex items-center gap-2">
          <UserAvatar name={author.name} size="sm" />
          <span className="text-sm font-medium">{author.name}</span>
        </div>
      ) : null,
      className: "w-[180px]",
    },
  ];

  return (
    <div className="h-10 justify-start items-start gap-14 inline-flex my-4">
      {properties.map((prop) => (
        <CasePropertyItem key={prop.label} {...prop} />
      ))}
    </div>
  );
};
